export function onDomReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(fn, 1);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

export function onFullyLoaded(fn) {
    window.addEventListener('load', () => {
        fn();
    });
}

export function getMeta(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);
    if (!metaEl) {
        return '';
    }

    return metaEl.getAttribute('content');
}

export function fadeIn(element) {
    element.style.opacity = 0;
    element.style.display = 'block';

    let last = +new Date();
    const tick = function () {
        element.style.opacity =
            +element.style.opacity + (new Date() - last) / 200;
        last = +new Date();

        if (+element.style.opacity < 1) {
            window.requestAnimationFrame(tick);
        }
    };

    tick();
}

export function fadeOut(element) {
    element.style.opacity = 1;

    let last = +new Date();
    const tick = function () {
        element.style.opacity =
            +element.style.opacity - (new Date() - last) / 200;
        last = +new Date();

        if (+element.style.opacity > 0) {
            window.requestAnimationFrame(tick);
        } else {
            element.style.display = 'none';
        }
    };

    tick();
}